import { Action } from '@ngrx/store';
import { JobBoard, JobSourcing } from '../models/job-sourcing';
import { FinnAdvertisement } from '../../lib/classes/finn/finnAdvertisement';

export enum JobSourcingActionTypes {
  LoadJobSourcing = '[JobSourcing] Load JobSourcing',
  LoadJobSourcingSuccess = '[JobSourcing] Load JobSourcing Success',
  JobSourcingFail = '[JobSourcing] Load JobSourcing Fail',
  PurchaseJobSourcingBoard = '[JobSourcing] Purchase JobSourcingBoard',
  PurchaseJobSourcingBoardSuccess = '[JobSourcing] Purchase JobSourcingBoard Success',
  PostFinnBoard = '[JobSourcing] Post Finn Board',
  PostFinnBoardSuccess = '[JobSourcing] Post Finn Board Success',
  SelectFinnBoard = '[JobSourcing] Select Finn Board',
  SelectFinnBoardSuccess = '[JobSourcing] Select Finn Board Success',
  PostEquestBoard = '[JobSourcing] Post Equest Board',
  PostEquestBoardSuccess = '[JobSourcing] Post Equest Board Success',
  UpdateJobSourcing = '[JobSourcing] Update JobSourcing',
  UpdateJobSourcingSuccess = '[JobSourcing] Update JobSourcing Success',
  CleanState = '[JobSourcing] Clean state',
}

export class UpdateJobSourcing implements Action {
  readonly type = JobSourcingActionTypes.UpdateJobSourcing;

  constructor(public payload: { jobSourcing: JobSourcing }) {}
}

export class UpdateJobSourcingSuccess implements Action {
  readonly type = JobSourcingActionTypes.UpdateJobSourcingSuccess;

  constructor(
    public payload: {
      jobSourcing: JobSourcing;
      error: any;
      isUpdateSuccess: boolean;
    }
  ) {}
}

export class LoadJobSourcing implements Action {
  readonly type = JobSourcingActionTypes.LoadJobSourcing;

  constructor(public payload: { jobId: number }) {}
}

export class LoadJobSourcingSuccess implements Action {
  readonly type = JobSourcingActionTypes.LoadJobSourcingSuccess;

  constructor(public payload: { jobSourcing: JobSourcing }) {}
}

export class JobSourcingFail implements Action {
  readonly type = JobSourcingActionTypes.JobSourcingFail;

  constructor(public payload: { errors: any }) {}
}

export class PurchaseJobSourcingBoard implements Action {
  readonly type = JobSourcingActionTypes.PurchaseJobSourcingBoard;

  constructor(
    public payload: {
      jobId: number;
    }
  ) {}
}

export class PurchaseJobSourcingBoardSuccess implements Action {
  readonly type = JobSourcingActionTypes.PurchaseJobSourcingBoardSuccess;

  constructor(public payload: { jobSourcing: JobSourcing }) {}
}

export class PostFinnBoard implements Action {
  readonly type = JobSourcingActionTypes.PostFinnBoard;

  constructor(
    public payload: {
      jobId: number;
      boardId: number;
    }
  ) {}
}

export class PostFinnBoardSuccess implements Action {
  readonly type = JobSourcingActionTypes.PostFinnBoardSuccess;

  constructor(public payload: { jobSourcing: JobSourcing }) {}
}

export class SelectFinnBoard implements Action {
  readonly type = JobSourcingActionTypes.SelectFinnBoard;

  constructor(
    public payload: {
      board: JobBoard;
    }
  ) {}
}

export class SelectFinnBoardSuccess implements Action {
  readonly type = JobSourcingActionTypes.SelectFinnBoardSuccess;

  constructor(public payload: { finnAdvertisement: FinnAdvertisement }) {}
}

export class PostEquestBoard implements Action {
  readonly type = JobSourcingActionTypes.PostEquestBoard;

  constructor(
    public payload: {
      jobId: number;
      boardId: number;
    }
  ) {}
}

export class PostEquestBoardSuccess implements Action {
  readonly type = JobSourcingActionTypes.PostEquestBoardSuccess;

  constructor(public payload: { equestDraft: any }) {}
}

export class CleanState implements Action {
  readonly type = JobSourcingActionTypes.CleanState;
}

export type JobSourcingActions =
  | LoadJobSourcing
  | LoadJobSourcingSuccess
  | JobSourcingFail
  | PurchaseJobSourcingBoard
  | PurchaseJobSourcingBoardSuccess
  | PostFinnBoard
  | PostFinnBoardSuccess
  | SelectFinnBoard
  | SelectFinnBoardSuccess
  | PostEquestBoard
  | PostEquestBoardSuccess
  | UpdateJobSourcing
  | UpdateJobSourcingSuccess
  | CleanState;
